import type { RouteObject } from 'react-router';
import CreateLottery from '../../pages/Lottery/Create';
import CreateDraw from '../../pages/Lottery/CreateDraw';
import LotteryDetails from '../../pages/Lottery/Details';
import DrawDetailsPage from '../../pages/Lottery/DrawDetails';
import DrawsList from '../../pages/Lottery/DrawsList';
import LotteryList from '../../pages/Lottery/List';
import NomineeApplications from '../../pages/Lottery/NomineeApplications';

export const LotteryRoute = () => {
  return [
    {
      index: true,
      element: <LotteryList />,
    },
    {
      path: 'create',
      element: <CreateLottery />,
    },
    {
      path: 'create-draw',
      element: <CreateDraw />,
    },
    {
      path: ':lotteryId',
      element: <LotteryDetails />,
    },
    {
      path: ':lotteryId/draws/:drawId',
      element: <DrawDetailsPage />,
    },
    {
      path: ':lotteryId/nominee-applications',
      element: <NomineeApplications />,
    },
    {
      path: 'draws',
      element: <DrawsList />,
    },
  ] as RouteObject[];
};
